if (!customElements.get('read-more')) {
  class ReadMore extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.holder = this.querySelector('[data-holder]');
      this.content = this.querySelector('[data-content]');

      this.checkTogglable();
      window.addEventListener('resize', () => {
        this.checkTogglable();
      });

      this.button = this.querySelector('[data-button]');
      this.button.addEventListener('click', () => {
        this.toggleReadMore();
      });
    }
    // Check if the element should have a read more button
    checkTogglable() {
      this.classList.remove('open');
      this.classList.remove('no-button');
      // Check the breakpoint and the height of the content compared to holder height
      if (window.innerWidth <= 768 && this.content.offsetHeight > this.holder.offsetHeight) {
        this.classList.remove('no-button');
      } else {
        this.classList.add('no-button');
      }
    }
    toggleReadMore() {
      this.classList.toggle('open');
    }
  }
  customElements.define('read-more', ReadMore);
}
